// pricingTaskSlice.ts
import { createSlice } from '@reduxjs/toolkit';
import { ApproverTaskItem } from '../interfaces/interfaces';
import { RootState } from '../../../redux/types';

export interface ApproverTaskState {
  tasksList: ApproverTaskItem[];
  selectedTasks: string[];
}

export const initialState: ApproverTaskState = {
  tasksList: [],
  selectedTasks: [],
};

export const domainApproverTaskSlice = createSlice({
  name: 'domainApproverTask',
  initialState,
  reducers: {
    setApproverTasks: (state, action) => {
      state.tasksList = action.payload;
    },
    setSelectedTasks: (state, action) => {
      const nid = action.payload;
      if (state.selectedTasks.includes(nid)) {
        state.selectedTasks = state.selectedTasks.filter(id => id !== nid);
      } else {
        state.selectedTasks.push(nid);
      }
    },
    clearSelectedTasks: state => {
      state.selectedTasks = [];
    },
    setDefaultState: () => {
      return initialState;
    },
  },
});

export const {
  setApproverTasks,
  setSelectedTasks,
  clearSelectedTasks,
  setDefaultState,
} = domainApproverTaskSlice.actions;

export default domainApproverTaskSlice.reducer;

export const getApproveTaskList = (state: RootState) =>
  state.domainApproverTask.tasksList;

export const getSelectedTasks = (state: RootState) =>
  state.domainApproverTask.selectedTasks;

export const getTaskTypeByNid = (
  state: RootState,
  nid: string
): string | undefined => {
  const matchingTasks = state.domainApproverTask.tasksList
    .filter(task => task.nid === nid)
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

  return matchingTasks[0]?.task_type;
};
